import Link from "next/link";
import { useState } from "react";
import dynamic from "next/dynamic";
import { NextSeo } from "next-seo";
import ErrorPage from "next/error";
import { useRouter } from "next/router";
import Layout from "@/components/layout/blog";

const Vacancy = dynamic(() => import("@/components/careers/vacancy"), {
  suspense: true,
});

export default function ContentWriter() {
  const router = useRouter();
  const post = router.query;
  const [isHovering, setIsHovering] = useState(false);

  if (!router.isFallback && !post) {
    return <ErrorPage statusCode={404} />;
  }

  const handleMouseEnter = () => {
    setIsHovering(true);
  };

  const handleMouseLeave = () => {
    setIsHovering(false);
  };

  return (
    <Layout>
      <NextSeo
        title="ISO Consultant needed for IS Auditr"
        keywords="ISO Consultant, ISO Auditor, Lead Auditor"
        canonical="https://isauditr.com/careers/iso-consultant"
        description="Are you qualified and certified to lead the IMS Audit process? We are seeking an ISO Consultant with experience and knowledge in auditing for ISO standards."
        twitter={{
          cardType: "summary_large_image",
          site: "@isauditr",
          handle: "@isauditr",
          creator: "@isauditr",
          title: "ISO Consultant needed for IS Auditr",
          description:
            "Are you qualified and certified to lead the IMS Audit process? We are seeking an ISO Consultant with experience and knowledge in auditing for ISO standards.",
        }}
        openGraph={{
          type: `article`,
          locale: `en_US`,
          siteName: "IS Auditr",
          title: "ISO Consultant needed for IS Auditr",
          description:
            "Are you qualified and certified to lead the IMS Audit process? We are seeking an ISO Consultant with experience and knowledge in auditing for ISO standards.",
          url: `https://isauditr.com/careers/iso-consultant`,
          publisherName: "IS Auditr",
          publisherLogo: "https://isauditr.com/images/logo.svg",
        }}
      />

      {router.isFallback ? (
        <div>Loading…</div>
      ) : (
        <div
          data-elementor-type="single-post"
          data-elementor-id="1403"
          className="elementor elementor-1403 elementor-location-single post-645 post type-post status-publish format-standard has-post-thumbnail hentry category-uncategorized"
        >
          <section
            className="elementor-section elementor-top-section elementor-element elementor-element-0e39b24 elementor-section-full_width elementor-section-height-default elementor-section-height-default"
            data-id="0e39b24"
            data-element_type="section"
          >
            <div className="elementor-container elementor-column-gap-no">
              <div
                className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-57f1572"
                data-id="57f1572"
                data-element_type="column"
              >
                <div className="elementor-widget-wrap elementor-element-populated">
                  <div
                    className="elementor-element elementor-element-0e3bf1b elementor-align-left elementor-widget elementor-widget-button"
                    data-id="0e3bf1b"
                    data-element_type="widget"
                    data-widget_type="button.default"
                  >
                    <div className="elementor-widget-container">
                      <div className="elementor-button-wrapper">
                        <Link
                          href="/careers"
                          className="elementor-button-link elementor-button elementor-size-sm elementor-animation-shrink"
                          role="button"
                        >
                          <span className="elementor-button-content-wrapper">
                            <span className="elementor-button-icon elementor-align-icon-left">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                id="fb1ba545-369a-4787-8f5c-a6afb4a11530"
                                data-name="Layer 1"
                                width="16.2764"
                                height="16.6475"
                                viewBox="0 0 16.2764 16.6475"
                              >
                                <path
                                  d="M16.2852,7.6343,3.498,7.6348,9.793,1.7412,8.4258.2812.3252,7.8652a1,1,0,0,0-.002,1.458l8.08,7.6055,1.3711-1.457L3.5723,9.6348H16.2852Z"
                                  transform="translate(-0.0088 -0.2813)"
                                ></path>
                              </svg>
                            </span>
                            <span className="elementor-button-text">
                              back to all
                            </span>
                          </span>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="elementor-column elementor-col-66 elementor-top-column elementor-element elementor-element-e713e97"
                data-id="e713e97"
                data-element_type="column"
              >
                <div className="elementor-widget-wrap elementor-element-populated">
                  <div
                    className="elementor-element elementor-element-15c6535 elementor-widget elementor-widget-theme-post-title elementor-page-title elementor-widget-heading"
                    data-id="15c6535"
                    data-element_type="widget"
                    data-widget_type="theme-post-title.default"
                  >
                    <div className="elementor-widget-container">
                      <h1 className="elementor-heading-title elementor-size-default">
                        ISO Consultant
                      </h1>
                    </div>
                  </div>

                  <div
                    className="elementor-element elementor-element-4bcecaf elementor-widget-divider--view-line elementor-widget elementor-widget-divider"
                    data-id="4bcecaf"
                    data-element_type="widget"
                    data-widget_type="divider.default"
                  >
                    <div className="elementor-widget-container">
                      <div className="elementor-divider">
                        <span className="elementor-divider-separator"></span>
                      </div>
                    </div>
                  </div>

                  <div
                    className="elementor-element elementor-element-33acc19 elementor-widget elementor-widget-theme-post-content"
                    data-id="33acc19"
                    data-element_type="widget"
                    data-widget_type="theme-post-content.default"
                  >
                    <div className="elementor-widget-container">
                      <div className="wp-block-columns">
                        <div
                          className="wp-block-column"
                          style={{ flexBasis: "300px" }}
                        >
                          <p>
                            <strong>Experience</strong>
                            <br />
                            2-10 years of relevant experience
                          </p>

                          <p>
                            <strong>Location</strong>
                            <br />
                            <meta charset="utf-8" />
                            Mohali, Punjab
                          </p>
                        </div>

                        <div className="wp-block-column">
                          <p>
                            We are looking for a ISO Consultant to join our
                            team.
                          </p>
                        </div>
                      </div>

                      <div
                        style={{ height: "50px" }}
                        aria-hidden="true"
                        className="wp-block-spacer"
                      ></div>

                      <h4>
                        <strong>Job brief</strong>
                      </h4>

                      <p>
                        Our growing company is searching for experienced
                        candidates for the position of ISO Consultant. We
                        appreciate you taking the time to review the list of
                        qualifications and to apply for the position. If you
                        don’t fill all of the qualifications, you may still be
                        considered depending on your level of experience.
                      </p>

                      <div
                        style={{ height: "50px" }}
                        aria-hidden="true"
                        className="wp-block-spacer"
                      ></div>

                      <h4>
                        <strong>Responsibilities</strong>
                      </h4>

                      <ul
                        style={{
                          listStyle: "disc",
                          listStylePosition: "inside",
                        }}
                      >
                        <li>Determine the scope and objectives of Audit</li>
                        <li>
                          Prepare ISO background as per standard and company
                          processes
                        </li>
                        <li>
                          Evaluate production processes for compliance with
                          quality requirements
                        </li>
                        <li>Participate in quality audits</li>
                        <li>
                          Identify processes, situations, etc., where
                          organization is meeting requirements, as well as
                          identify opportunities for improvement
                        </li>
                        <li>
                          Assist audit team in developing audit reports; present
                          audit reports to top management, as needed
                        </li>
                        <li>Assist with follow-up audits, as required</li>
                        <li>
                          May be required to develop internal auditing/testing
                          parameters
                        </li>
                        <li>
                          Interface with clients to discover their business
                          challenges
                        </li>
                        <li>
                          Perform quantitative and observational data analyses
                        </li>
                        <li>Create and present client recommendations</li>
                      </ul>

                      <div
                        style={{ height: "50px" }}
                        aria-hidden="true"
                        className="wp-block-spacer"
                      ></div>

                      <h4>
                        <strong>Qualifications</strong>
                      </h4>

                      <ul
                        style={{
                          listStyle: "disc",
                          listStylePosition: "inside",
                        }}
                      >
                        <li>
                          Accredited Lead Auditor on QSR/ ISO Lead Training (ASQ
                        </li>
                        <li>
                          Strong knowledge of and compliance of ISO 9001, ISO
                          27001, ISO 14001 and OHSAS 18001
                        </li>
                        <li>
                          Strong analytical, communication and quantitative
                          skills
                        </li>
                        <li>Demonstrated proficiency in MS Excel</li>
                        <li>Strong presentation and communication skills</li>
                        <li>
                          Bachelor&apos;s degree and greater than four years of
                          relevant professional experience
                        </li>
                        <li>
                          Working knowledge of identifying and assessing risks
                          and internal controls
                        </li>
                        <li>
                          Help to plan internal control audit approach & scope,
                          including control & site selection, audit scheduling,
                          and resourcing
                        </li>
                      </ul>
                    </div>
                  </div>

                  <Link
                    rel="noopener"
                    href="https://www.linkedin.com/jobs/view/3517140932"
                    className="elementor-button-link elementor-button elementor-size-md"
                    role="button"
                    target="_blank"
                    style={{
                      fontFamily: '"Inter",Sans-serif',
                      fontSize: "16px",
                      fontWeight: 500,
                      textTransform: "capitalize",
                      fontStyle: "normal",
                      textDecoration: "none",
                      lineHeight: "1em",
                      letterSpacing: "-0.2px",
                      wordSpacing: "0px",
                      fill: "#E23125",
                      color: isHovering ? "#ffffff" : "#E23125",
                      backgroundColor: isHovering ? "#E23125" : "#FFFFFF00",
                      borderStyle: "solid",
                      borderWidth: "2px",
                      borderColor: "#E23125",
                      borderRadius: "60px 60px 60px 60px",
                      marginTop: "60px",
                    }}
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                  >
                    <span className="elementor-button-content-wrapper">
                      <span className="elementor-button-text">Apply Now</span>
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          </section>

          <section
            className="elementor-section elementor-top-section elementor-element elementor-element-62ac14c elementor-section-full_width elementor-section-height-default elementor-section-height-default"
            data-id="62ac14c"
            data-element_type="section"
          >
            <div className="elementor-container elementor-column-gap-no">
              <div
                className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-4734801"
                data-id="4734801"
                data-element_type="column"
              >
                <div
                  className="elementor-widget-wrap elementor-element-populated"
                  style={{
                    padding: "2%",
                    margin: "5%",
                    borderStyle: "solid",
                    borderWidth: "2px 0 0",
                    borderColor: "#E23125",
                    transition:
                      "background .3s,border .3s,border-radius .3s,box-shadow .3s",
                  }}
                >
                  <div
                    className="elementor-element elementor-element-f6f9ffc elementor-widget elementor-widget-heading"
                    data-id="f6f9ffc"
                    data-element_type="widget"
                    data-widget_type="heading.default"
                  >
                    <div
                      className="elementor-widget-container"
                      style={{
                        margin: "5% 0%",
                      }}
                    >
                      <h3 className="elementor-heading-title elementor-size-default">
                        Check out some other job posts
                      </h3>
                    </div>
                  </div>
                  <Vacancy
                    title="Content Writer"
                    type="Full Time"
                    slug="content-writer"
                    location="Mohali, Punjab"
                    exceprt="We are looking for a Content Writer to join our editorial team and enrich our websites with new blog posts, guides and marketing copy."
                  />

                  <Vacancy
                    title="Social Media Executive"
                    type="Full Time"
                    slug="social-media-executive"
                    location="Mohali, Punjab"
                    exceprt="We are looking for a social media executive to oversee our company's presence on a multitude of public platforms."
                  />
                </div>
              </div>
            </div>
          </section>
        </div>
      )}
    </Layout>
  );
}
